// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax } from 'components/styles/_media'
import { imagePath } from 'frontend_core/dist/helpers/image'

export const Container = styled.div`
  border: 1px solid ${Colors.grayD};
  background-color: ${Colors.white};
  border-radius: 3px;
  padding: 12px 8px;
  margin-top: 1em;
`

export const AuthenticactionIcon = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  float: left;
`

export const AuthenticationCheck = styled.div`
  margin-left: 52px;
  font-size: 10px;
`

export const AuthenticationHeadline = styled.h3`
  color: #999;
  line-height: 1.3;
  letter-spacing: -1px;
  padding-top: 6px;
  margin-bottom: 4px;
  ${mediaMax.desktop`
    padding-top: 2px;
  `} ${mediaMax.tablet`
    padding-top: 6px;
  `};
`

export const CheckList = styled.ul`
  .fa {
    margin-right: 4px;
    color: ${Colors.green};
  }
`

export const CheckListItem = styled.li`
  display: inline;
  margin-right: 4px;
  ${mediaMax.desktopLg`
    display: block;
    margin-top: 4px;
  `};
`

export default class HostCertificatedBox extends React.Component<Object> {
  render() {
    return (
      <Container className="clearfix">
        <AuthenticactionIcon
          src={imagePath('www/common/confirm.svg')}
          alt="スペースマーケット認証マーク"
        />
        <AuthenticationCheck>
          <AuthenticationHeadline>
            {i18n.t('page.room.certificated')}
          </AuthenticationHeadline>
          <CheckList>
            <CheckListItem>
              <i className="fa fa-check" />
              {i18n.t('page.room.certEmail')}
            </CheckListItem>
            <CheckListItem>
              <i className="fa fa-check" />
              {i18n.t('page.room.certTel')}
            </CheckListItem>
            <CheckListItem>
              <i className="fa fa-check" />
              {i18n.t('page.room.certIdentify')}
            </CheckListItem>
          </CheckList>
        </AuthenticationCheck>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/room/HostCertificatedBox/index.jsx